export default class DxfPropertiesManager {
  constructor() {}
  /**
   * Parses the Color of an entity
   * @param {*} data dxf-data
   * @param {*} entity Entity, contains it's own layer
   * @param {*} insert The insert object, contains it's own layer
   */
  parseColor(data, entity, insert) {
    const insertLayer = insert && insert.layer;

    const insertColor = insert && insert.color;
    const insertColorIndex = insert && insert.colorIndex;
    const insertLayerColor = insertLayer && data.layers[insertLayer].color;

    const entityColor = entity.color;
    const entityColorIndex = entity.colorIndex;
    const entityLayerColor = data.layers[entity.layer] && data.layers[entity.layer].color;

    //By Layer, 256 or missing colorIndex indicates by layer.
    const byLayer = 256;
    const byBlock = 0;
    const byEntity = 7; //Note: 7 is normally black/white but seems to be an exception when its 7 on an insert and then it defaults to entity

    //Colored entity

    //Entity
    if (entityColor !== undefined && entityColorIndex !== byBlock && entityColorIndex !== byLayer) {
      return entityColor;
    }

    //By Layer
    if (
      (entityColorIndex === byLayer ||
        (this.isDefaultLayer(entity.layer) === false && entityColorIndex !== byBlock)) &&
      entityLayerColor !== undefined
    ) {
      return entityLayerColor;
    }

    //Non colored entity

    //By Insert layer
    if (insertColorIndex === byLayer && insertLayerColor !== undefined) {
      return insertLayerColor;
    }

    //By Insert Color
    if (insertColorIndex !== byEntity && insertColor !== undefined) {
      return insertColor;
    }

    //Fallback insert layer
    if (insertColorIndex !== byEntity && insertLayerColor !== undefined) {
      return insertLayerColor;
    }

    //Fallback entity layer
    if (entityLayerColor !== undefined) {
      return entityLayerColor;
    }

    console.error('Failed parsing color', entity, insert);
    return 0;
  }

  isDefaultLayer(layer) {
    return layer === 0 || layer === '0' || layer === undefined;
  }
  /**
   * Parses the LineType of an entity
   * @param {*} data dxf-data
   * @param {*} entity Entity, contains it's own layer
   * @param {*} insert The insert object, contains it's own layer
   */
  parseLineType(data, entity, insert) {
    const result = this.resolveLineTypeAndScale(data, entity, insert);

    if (
      result.type.toUpperCase() ===
      'CONTINUOUS' /* || entity.hasContinuousLineresult.typePattern === false */
    ) {
      return { scale: 1, pattern: [] };
    }

    if (!data.lineTypes[result.type]) {
      console.log({
        message: 'Missing Linetype, Defaulted to continuous line',
        debugInfo: { type: result.type, entity: entity, data: data, insert: insert },
      });
      return { scale: 1, pattern: [] };
    }

    const pattern =
      data.lineTypes[result.type].patternLength === 0
        ? []
        : data.lineTypes[result.type].pattern.map((elem) => {
            return elem;
          });

    return { scale: result.scale, pattern };
  }

  resolveLineTypeAndScale(data, entity, insert) {
    const defaultScale = 1;

    const insertLayer = insert && insert.layer;

    const insertLineType = insert && insert.lineType;
    const insertLineTypeScale = insert && insert.lineTypeScale;

    const insertLayerLineType =
      insertLayer && data.layers[insertLayer] && data.layers[insertLayer].lineType;
    const insertLayerLineTypeScale =
      insertLayer && data.layers[insertLayer] && data.layers[insertLayer].lineTypeScale;

    const entityLineType = entity.lineType;
    const entityLineTypeScale = entity.lineTypeScale;

    const entityLayerLineType = data.layers[entity.layer] && data.layers[entity.layer].lineType;
    const entityLayerLineTypeScale =
      data.layers[entity.layer] && data.layers[entity.layer].lineTypeScale;

    //If present linetype is taken from entity, otherwise it is taken from layer where insert layer gets priority over entity layer
    if (entityLineType !== undefined) {
      if (entityLineType.toUpperCase() === 'BYLAYER' && entityLayerLineType !== undefined) {
        return {
          type: entityLayerLineType,
          scale: entityLayerLineTypeScale || defaultScale,
        };
      }

      if (entityLineType.toUpperCase() === 'BYBLOCK' && insertLineType !== undefined) {
        return {
          type: insertLineType,
          scale: insertLineTypeScale || defaultScale,
        };
      }

      return {
        type: entityLineType,
        scale: entityLineTypeScale || defaultScale,
      };
    }

    //Second priority is by insert layer
    if (insertLayerLineType !== undefined) {
      return {
        type: insertLayerLineType,
        scale: insertLayerLineTypeScale || defaultScale,
      };
    }

    //Last priority is by entity layer
    if (entityLayerLineType !== undefined) {
      return {
        type: entityLayerLineType,
        scale: entityLayerLineTypeScale || defaultScale,
      };
    }

    console.error('Unable to resolve linetype', entity, insert);
    return { type: 'CONTINUOUS', scale: defaultScale };
  }

  /**
   * Parses the LineWidth of an object
   * @param {*} data dxf-data
   * @param {*} entity Entity, contains it's own layer
   * @param {*} blockLayer The layer which the block is located in, if the entity is in a block
   */
  parseLineWidth(data, entity, insert) {
    if (!insert) {
      insert = {};
    }
    var blockLayer = insert.layer ? insert.layer : '0';

    let weight = 100;
    let thickness = 0.5;

    if (entity.thickness) {
      thickness = entity.thickness;
    }

    if (entity.width) {
      thickness = entity.width + 2.5;
    }

    if (entity.lineweight || insert.lineweight) {
      if (insert.lineweight === -3 || entity.lineweight === -3) {
        //Standard
        return 1 * thickness;
      } else if (insert.lineweight === -2 || entity.lineweight === -2) {
        //By Layer
        weight = data.layers[entity.layer].lineweight;
      } else if (insert.lineweight === -1 || entity.lineweight === -1) {
        //By Block
        if (blockLayer === '0') {
          weight = data.layers[entity.layer].lineweight;
        } else {
          weight = data.layers[blockLayer].lineweight;
        }
      }
    } else {
      weight = data.layers[entity.layer].lineweight;
      if (!weight) {
        weight = data.layers[blockLayer].lineweight
          ? data.layers[blockLayer].lineweight
          : data.layers['0'].lineweight;
      }
    }

    if (weight === -3) {
      return 1 * thickness;
    } else if (weight < 0 || weight === null || isNaN(weight)) {
      console.log({
        message: 'Warning! Unresolved linewidth, investigate!',
        data: data,
        insert: insert,
        entity: entity,
      });
      return 1 * thickness;
    } else {
      return thickness * (weight / 100);
    }
  }

  /**
   * Compares properties to see if they are the same or not
   * @param {*} list list of already added properties for that layer
   * @param {*} properties properties of currently processed line
   */
  findMatchingProperties(list, properties) {
    for (let i = 0; i < list.length; i++) {
      let colorMatch = list[i].properties.color === properties.color;
      let lineWidthMatch = list[i].properties.lineWidth === properties.lineWidth;

      let lineTypeMatch =
        (list[i].properties.lineType && properties.lineType) ||
        (!list[i].properties.lineType && !properties.lineType);

      if (list[i].properties.lineType && properties.lineType) {
        if (list[i].properties.lineType.length === properties.lineType.length) {
          for (let j = 0; j < properties.lineType.length; j++) {
            if (list[i].properties.lineType[j] !== properties.lineType[j]) {
              lineTypeMatch = false;
            }
          }
        } else {
          lineTypeMatch = false;
        }
      }

      if (colorMatch && lineWidthMatch && lineTypeMatch) {
        return i;
      }
    }

    return false;
  }
}
